import { compose } from 'redux';
import { connect } from 'react-redux';
import { defineResources } from 'tpt-connect';

import { currentUserResourceDefinition } from 'dpl/util/tptConnectResourceDefinitions';

export default function withCurrentUser(WrappedComponent) {
  return compose(
    defineResources(() => ({
      currentUser: currentUserResourceDefinition()
    }), { pure: false }),
    connect((_state, { currentUser }) => {
      const { meta, value } = currentUser;

      let isLoggedIn = null;
      let isBreeder = null;
      let isBuyer = null;

      if (meta.isError || (meta.isSuccess && !value.data)) {
        isLoggedIn = false;
      } else if (meta.isSuccess) {
        isLoggedIn = true;
        isBreeder = value.data.breeder;
        isBuyer = value.data.buyer;

        if (window.bugsnagClient) {
          window.bugsnagClient.user = {
            ...window.bugsnagClient.user,
            ...value.data
          };
        }
      }

      return {
        isLoggedIn,
        login: currentUser.login,
        isBreeder,
        isBuyer
      };
    }, null, null, { pure: false }),
  )(WrappedComponent);
}
